import styles from './product-structure-group-details-grid-renderer.module.scss';
import { ValueFormatterParams } from 'ag-grid-community';
import { useState } from 'react';
import { Col, Row } from 'reactstrap';
import { Box, Container, CreateHeaders, HeaderSizeEnum, SecondaryButton, textHeader } from '@frontend-workspace/react-shared-lib';
import { IRelationProductGroups } from '../../_models/relation-product-groups';
import { IRelationProduct } from '../../_models/relation-product';
import { WebkuaTable } from '@frontend-workspace/webkua-lib';
import { useTranslation } from 'react-i18next';

/* eslint-disable-next-line */
export interface ProductStructureGroupDetailsGridRendererProps {
  data: IRelationProductGroups
}

export function ProductStructureGroupDetailsGridRenderer(props: ProductStructureGroupDetailsGridRendererProps) {
  const { t } = useTranslation();
  const [deleteProduct, setDeleteProduct] = useState<IRelationProduct>();

  const openDeleteProductDialog = (e: any) => setDeleteProduct(e.data);
  const closeDeleteProductDialog = () => setDeleteProduct(undefined);

  const deleteProductRenderer = (params: ValueFormatterParams) => (
    <SecondaryButton
      variant="outlined"
      size='small'
      onClick={() => openDeleteProductDialog(params)}>
      {t("standard.deleteProduct")}
    </SecondaryButton>
  );

  return <>
    {props.data.mainProducts &&
      <Box sx={{ padding: '20px 0' }}>
        <Container>
          <Row>
            <Col>
              <WebkuaTable
                headers={CreateHeaders([
                  textHeader("productName", t("standard.products"), HeaderSizeEnum.EXTRA_LARGE)
                  // textHeader("", "", HeaderSizeEnum.SMALL, {
                  //   renderer: deleteProductRenderer,
                  //   cellStyle: { justifyContent: 'right' },
                  //   headerClass: "ag-right-aligned-header"
                  // })
                ])}
                data={props.data.mainProducts}
              />
            </Col>
          </Row>
        </Container>
      </Box>
    }
    {/* {deleteProduct && <DeleteProductDialog
      open={!!deleteProduct}
      onClose={closeDeleteProductDialog}
      groupId={props.data?.id}
      productId={deleteProduct.id}
      productName={deleteProduct.productName}
    />} */}
  </>;
}

export default ProductStructureGroupDetailsGridRenderer;